import React from 'react';
import { Box, Container, Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Timeline as TimelineIcon, Home as HomeIcon } from '@mui/icons-material';
import SCADAHistorian from '../../components/SCADA/SCADAHistorian';

const HistorianPage: React.FC = () => {
  const location = useLocation();

  return (
    <Container maxWidth="xl">
      {/* Breadcrumbs */}
      <Box sx={{ my: 2 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            component={RouterLink}
            to="/"
            color="inherit"
            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
          >
            <HomeIcon fontSize="small" />
            Dashboard
          </Link>
          <Typography 
            color="text.primary" 
            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
          >
            <TimelineIcon fontSize="small" />
            SCADA Historian
          </Typography>
        </Breadcrumbs>
      </Box>

      {/* Main Content */}
      <SCADAHistorian />
    </Container>
  );
};

export default HistorianPage; 